import Marquee from "react-fast-marquee";
import { useTheme } from "next-themes";

const ITEMS = ["UI/UX", "Web Design", "Front-end", "Responsive", "Branding", "AI"];

export const WhoIWorkWith = () => {
  const { resolvedTheme } = useTheme();
  const gradientColor = resolvedTheme === "dark" ? "#100D1B" : "#F7F5FF";

  return (
    <section className="py-14 lg:py-20 border-y border-line" data-testid="who-section">
      <Marquee speed={30} gradient gradientColor={gradientColor} gradientWidth={140}>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <div key={i} className="flex items-center mx-8 lg:mx-12" data-testid={`marquee-item-${i}`}>
            <span className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-ink/90">{t}</span>
            <span className="w-2.5 h-2.5 rounded-full btn-gradient ml-8 lg:ml-12" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
